<template>
  <CustomDialog :visible="showDialog" @confirm="updateUserData" @close="$emit('closeDialog')" title="Update user" >
    <template v-slot:body>
      <div class="update-form-wrapper">
        <span>First name</span>
        <el-input class="input" placeholder="First name" v-model="firstName">{{user.first_name}}</el-input>
        <p v-if="errorMessage && !firstName" class="errorMessage">{{ errorMessage }}</p>

        <span>Last name</span>
        <el-input class="input" placeholder="Last name" v-model="lastName">{{user.last_name}}</el-input>
        <p v-if="errorMessage && !lastName" class="errorMessage">{{ errorMessage }}</p>

        <span>Email</span>
        <el-input class="input" placeholder="Email" v-model="email">{{user.email}}</el-input>
        <p v-if="errorMessage && !email" class="errorMessage">{{ errorMessage }}</p>

        <span>Phone number</span>
        <el-input class="input" placeholder="Phone number" v-model="phoneNumber">{{user.phone_number}}</el-input>
        <p v-if="errorMessage && !phoneNumber" class="errorMessage">{{ errorMessage }}</p>

        <span>Company name</span>
        <el-input class="input" placeholder="Company name" v-model="companyName">{{user.company_name}}</el-input>
        <p v-if="errorMessage && !companyName" class="errorMessage">{{ errorMessage }}</p>

        <span>State or province</span>
        <el-input class="input" placeholder="State or province" v-model="stateOrProvince">{{user.state_or_province}}</el-input>
        <p v-if="errorMessage && !stateOrProvince" class="errorMessage">{{ errorMessage }}</p>

        <span>City</span>
        <el-input class="input" placeholder="City" v-model="city">{{user.city}}</el-input>
        <p v-if="errorMessage && !city" class="errorMessage">{{ errorMessage }}</p>

        <span>Address</span>
        <el-input class="input" placeholder="City" v-model="address">{{user.address}}</el-input>
        <p v-if="errorMessage && !address" class="errorMessage">{{ errorMessage }}</p>
      </div>
    </template>
  </CustomDialog>
</template>

<script>
  import CustomDialog from "../CustomDialog";
  import { required } from "vuelidate/lib/validators";

  export default {

    validations: {
      firstName: {required},
      lastName: {required},
      phoneNumber: {required},
      companyName: {required},
      stateOrProvince: {required},
      city: {required},
      address: {required},
      email: {required},
    },


    props: {
      showDialog: {
        type: Boolean,
        default: false
      },
      user: Object
    },

    data() {
      return {
        firstName: '',
        lastName: '',
        phoneNumber: '',
        companyName: '',
        stateOrProvince: '',
        city: '',
        address: '',
        email: '',
        errorMessage: '',
      }
    },

    watch: {
      showDialog(val) {
        if (val) {
          this.firstName = this.user.first_name
          this.lastName = this.user.last_name
          this.phoneNumber = this.user.phone_number
          this.companyName = this.user.company_name
          this.stateOrProvince = this.user.state_or_province
          this.city = this.user.city
          this.address = this.user.address
          this.email = this.user.email
        }
      },
    },

    methods: {
      async updateUserData() {
        if (this.$v.$invalid) {
          this.errorMessage = 'All field must be filled'
          this.$v.$touch();
          return;
        }

        this.$emit('closeDialog')
        this.$emit('refreshData')

        await this.$store.dispatch('request', {
          path: 'admin/updates/users/data',
          body: {...this.user,
            first_name: this.firstName,
            last_name: this.lastName,
            phone_number: this.phoneNumber,
            company_name: this.companyName,
            state_or_province: this.stateOrProvince,
            city: this.city,
            address: this.address,
            email: this.email
          }
        });
      },
    },

    components: { CustomDialog }
  }
</script>

<style lang="scss" scoped>
  .errorMessage {
    color: #cc3f55;
    margin-top: 0;
  }
</style>
